export const TAG_COLORS = {
    warning: { backgroundColor: '#ffba00', color: 'black', opacity: 0.75 },
    success: { backgroundColor: '#00a400', color: 'black', opacity: 0.75  },
    error: { backgroundColor: '#fa383e', color: 'black', opacity: 0.75 },
    info: { backgroundColor: '#54c7ec', color: 'black', opacity: 0.75 },
}

export const SEPARATOR = "_____"